module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 20\">\n\t<path d=\"M16,2H8A2,2,0,0,0,6,4V21a1,1,0,0,0,1.7.7L12,17.4l4.3,4.3a1,1,0,0,0,.7.3h.4A1,1,0,0,0,18,21V4A2,2,0,0,0,16,2Z\" transform=\"translate(-6 -2)\" />\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/bookmarked.svg
// module id = 782
// module chunks = 1